import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CommonLayout } from '../commonComponents';
import InvestorLoginViewProfile from './viewProfile';
import InvestorProfile from '.';
import MutualFund from './mutualFund';
import OrderDetails from './mutualFund/orders/OrderDetails';
import ExploreMutualFund from './exploreMutualFund';
import IndividualFundDetails from './fundDetails';
import DownloadUploadXSIP from './mutualFund/mandates/DownloadUploadXSIP';
// import SwitchAndStp from './mutualFund/SwitchAndStp';
import ViewProfile from './viewProfile';
import CategoryWiseActionItems from './mutualFund/CategoryWiseActionItems';
import DirectEquity from './directEquity';
import PMS from './pms';
import Bonds from './bonds';
import Alternates from './alternates';
// import Redeem from './mutualFund/Redeem';
import Redeem from './mutualFund/redeem/index';
import ReasonForCancellation from './mutualFund/systematicPlans/ReasonForCancellation';
import EditRiskProfile from './EditRiskProfile';
import Transaction from './transcation';
import Swp from './mutualFund/swp/index';
import SwitchAndStp from './mutualFund/switchAndStp/index';
import CheckandVerifyOtp from './mutualFund/systematicPlans/CheckandVerifyOtp';
import PauseSIP from './mutualFund/systematicPlans/PauseSIP';
// import EcasDownloads from './eCasDownloads';
import SelectedCategorySchemes from './exploreMutualFund/SelectedCategorySchemes';
import SIPCalculator from './exploreMutualFund/SIPCalculator';
// import GoalCalculator from './exploreMutualFund/GoalCalculator';
import ProtectedRoute from '../../routes/ProtectedRoute';
import { USER_ROLES } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { isModuleAllowed } from '../../utils/utilityFunctions';
import Insurance from './insurance';
import GoalCalculator from './exploreMutualFund/GoalCalculator';
import IndividualPaymentScreen from './IndividualPaymentScreen';


const routerList = [
    {
        name: 'Investor Dashboard',
        path: "",
        component: InvestorProfile,
    },
    {
        name: "Edit Risk Profile",
        path: "edit-risk-profile",
        component: EditRiskProfile,
    },
    {
        name: 'Investor Profile',
        path: "view-profile",
        component: ViewProfile,
    },
    // {
    //     name: 'Investor Mutual Funds',
    //     path: "mutual-fund",
    //     component: MutualFund,
    // },
    // {
    //     name: 'Investor Direct Equity',
    //     path: "direct-equity",
    //     component: DirectEquity,
    // },
    // {
    //     name: 'Investor PMS',
    //     path: 'pms',
    //     component: PMS,
    // },
    // {
    //     name: 'Investor Debt',
    //     path: 'debt',
    //     component: Bonds,
    // },
    // {
    //     name: 'Investor Alternates',
    //     path: 'alternates',
    //     component: Alternates,
    // },
    // {
    //     name: 'Category Wise Breakup',
    //     path: 'mutual-fund/category-wise-breakup',
    //     component: CategoryWiseActionItems
    // },
    {
        name: 'Order Details',
        path: 'mutual-fund/:orderId/order-details',
        component: OrderDetails,
    },
    {
        name: 'Initiate Payment',
        path: 'mutual-fund/:orderId/order-details/initiate-payment',
        component: IndividualPaymentScreen
    },
    {
        name: 'OTP Screen',
        path: 'mutual-fund/:typeid/otp-screen',
        component: CheckandVerifyOtp,
    },
    {
        name: 'Pause SIP',
        path: 'mutual-fund/pause-sip',
        component: PauseSIP
    },
    {
        name: 'OTP Screen',
        path: 'mutual-fund/otp-screen',
        component: CheckandVerifyOtp,
    },
    {
        name: 'Reason for cancellation',
        path: 'mutual-fund/:typeid/reason-for-cancellation',
        component: ReasonForCancellation,
    },
    {
        name: 'Cancel OTP Screen',
        path: 'mutual-fund/:typeid/reason-for-cancellation/cancel-otp-screen',
        component: CheckandVerifyOtp,
    },
    {
        name: 'Explore Mutual Funds',
        path: 'mutual-fund/explore',
        component: ExploreMutualFund,
    },
    {
        name: 'SIP Calculator',
        path: 'mutual-fund/explore/sip-calculator',
        component: SIPCalculator
    },
    {
        name: 'Goal Calculator',
        path: 'mutual-fund/explore/goal-calculator',
        component: GoalCalculator
    },
    {
        name: 'Selected Category Funds',
        path: 'mutual-fund/explore/selected-category-funds',
        component: SelectedCategorySchemes,
    },
    // {
    //     name: 'eCAS Reports',
    //     path: 'mutual-fund/ecas-reports',
    //     component: EcasDownloads,
    // },
    {
        name: 'Fund Details',
        path: 'mutual-fund/explore/selected-category-funds/investment-details',
        // component: InvestmentDetails,
        component: Transaction,
        // component: TestInvestment,
    },
    {
        name: 'Individual Fund Dashboard',
        path: 'mutual-fund/explore/selected-category-funds/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Individual Fund Details',
        path: 'mutual-fund/explore/selected-category-funds/:individualFundId/investment-details',
        // component: InvestmentDetails,
        component: Transaction,
    },
    {
        name: 'Individual Fund Box',
        path: 'mutual-fund/explore/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Individual Fund Box',
        path: 'mutual-fund/explore/:individualFundId/investment-details',
        component: Transaction,
    },
    {
        name: 'Invest More',
        path: 'mutual-fund/invest-more',
        // component: InvestmentDetails,
        component: Transaction,
    },
    {
        name: 'Reedem',
        path: 'mutual-fund/redeem',
        component: Redeem,
    },
    {
        name: 'Switch',
        path: 'mutual-fund/switch',
        component: SwitchAndStp,
    },
    {
        name: 'STP',
        path: 'mutual-fund/stp',
        component: SwitchAndStp,
    },
    {
        name: 'SWP',
        path: 'mutual-fund/swp',
        // component: SWP,
        component: Swp
    },
    {
        name: 'DownloadUploadXSIP',
        path: 'mutual-fund/download-upload-xsip',
        component: DownloadUploadXSIP,
    },
]

function Routes(): JSX.Element {
    const { path } = useRouteMatch();

    const { role = '', permissions = [] } = useSelector((state: RootStateType) => state.auth);

    return (
        <>
            <Switch>
                {
                    routerList.map((
                        {
                            path: componentPath,
                            component: Component
                        }: {
                            path: string;
                            component: React.ComponentType<any>
                        },
                        index: number
                    ) => {
                        return (
                            <Route
                                exact
                                key={index}
                                path={componentPath ? `${path}/${componentPath}` : path}
                                render={() => (
                                    <CommonLayout>
                                        <Component />
                                    </CommonLayout>
                                )}
                            />
                        )
                    })
                }
                <ProtectedRoute
                    exact
                    path={`${path}/mutual-fund`}
                    component={MutualFund}
                    acceptedRoles={[USER_ROLES.INVESTOR]}
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/mutual-fund/category-wise-breakup`}
                    component={CategoryWiseActionItems}
                    acceptedRoles={[USER_ROLES.INVESTOR]}
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/direct-equity`}
                    component={DirectEquity}
                    customAuthorizationCheck={
                        [USER_ROLES.INVESTOR].includes(role) &&
                        isModuleAllowed({ value: "DirectEQDashboard", compareArr: permissions, objKey: "permissonCode" })
                    }
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/pms`}
                    component={PMS}
                    customAuthorizationCheck={
                        [USER_ROLES.INVESTOR].includes(role) &&
                        isModuleAllowed({ value: "PMSDashboard", compareArr: permissions, objKey: "permissonCode" })
                    }
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/debt`}
                    component={Bonds}
                    customAuthorizationCheck={
                        [USER_ROLES.INVESTOR].includes(role) &&
                        isModuleAllowed({ value: "DebtDashboard", compareArr: permissions, objKey: "permissonCode" })
                    }
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/alternates`}
                    component={Alternates}
                    customAuthorizationCheck={
                        [USER_ROLES.INVESTOR].includes(role) &&
                        isModuleAllowed({ value: "AIFDashboard", compareArr: permissions, objKey: "permissonCode" })
                    }
                    layout={CommonLayout}
                />
                <ProtectedRoute
                    exact
                    path={`${path}/insurance`}
                    component={Insurance}
                    customAuthorizationCheck={
                        [USER_ROLES.INVESTOR].includes(role) &&
                        isModuleAllowed({ value: "INSDashboard", compareArr: permissions, objKey: "permissonCode" })
                    }
                    layout={CommonLayout}
                />
            </Switch >
        </>
    );
}

export default function InvestorLoginRouter(): JSX.Element {

    return (
        // <CommonLayout>
        <Routes />
        // </CommonLayout>
    )
}
